export enum MetricsMenuOptions {
  DUPLICATE = "Duplicate",
  EDIT_PERMISSIONS = "Edit permissions",
  RENAME = "Rename",
}
